import { dateFormatter } from "../../general/functions";
import { BASE_URL } from "../../general/variables";

const parseNumber = function (str) {
    if (!str) return 0; // kalau kosong, langsung return 0

    // Hilangkan titik ribuan
    let clean = str.replace(/\./g, '');

    // Ganti koma menjadi titik untuk float JS
    clean = clean.replace(',', '.');

    const num = parseFloat(clean);
    return isNaN(num) ? 0 : num; // fallback ke 0 kalau hasil NaN
};

const formatNumber = function (num) {
    // Pakai Intl.NumberFormat untuk format Indonesia
    return new Intl.NumberFormat('id-ID', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(num);
}

function parseMysqlNumber(str) {
    if (str === null || str === undefined || str === '') {
        return 0;
    }

    // Pastikan tipe string
    str = String(str).trim();

    // Jika mengandung koma → format Indonesia/Eropa (1.599,40)
    if (str.includes(',')) {
        str = str.replace(/\./g, ''); // hapus pemisah ribuan
        str = str.replace(',', '.');  // ubah koma jadi titik
        return parseFloat(str) || 0;
    }

    // Jika tidak ada koma → asumsikan format MySQL/US decimal
    return parseFloat(str) || 0;
}

const generateStaging = function (staging) {

    let curLabel, curString;

    switch (staging) {
        case 'NEW':
            curLabel = ' label-light-success ';
            curString = 'NEW'
            break;
        case 'ACTIVE':
            curLabel = ' label-light-primary ';
            curString = 'ACTIVE'
            break;
        case 'INACTIVE':
            curLabel = ' label-light-danger ';
            curString = 'INACTIVE'
            break;
        case 'FINISHED':
            curLabel = ' label-light-info ';
            curString = 'FINISHED'
            break;
        case 'CLOSED':
            curLabel = ' label-light-warning ';
            curString = 'CLOSED'
            break;
        case 'CANCELED':
            curLabel = ' label-light-danger ';
            curString = 'CANCEL'
            break;
        case 'CANCEL':
            curLabel = ' label-light-danger ';
            curString = 'CANCEL'
            break;
        case 'COMPLETE':
            curLabel = ' label-light-warning ';
            curString = 'COMPLETE'
            break;
        case 'DONE':
            curLabel = ' label-light-dark ';
            curString = 'DONE'
            break;
        case 'OPEN':
            curLabel = ' label-light-dark ';
            curString = 'OPEN'
            break;
    }

    return {
        label: curLabel,
        text: curString
    };

}

const studentTable = $('#studentTable').KTDatatable({
    data: {
        type: 'remote',
        saveState: false,
        source: {
            read: {
                url: BASE_URL + 'C_Finance/getStudentTrackingList',
                params: {
                    type: 'UNIVERSITY'
                },
                map: function (raw) {
                    var dataSet = raw;

                    // $('#studentCounter').html(parseInt(raw.meta.total).toLocaleString('id-ID'))

                    switch (raw.meta.type) {
                        case 'UNIVERSITY':
                            $('#insuranceContainer').hide()
                            $('#accomodationContainer').hide()
                            break;

                        case 'ACCOMODATION':
                            $('#insuranceContainer').hide()
                            $('#accomodationContainer').show()
                            break;

                        case 'INSURANCE':
                            $('#insuranceContainer').show()
                            $('#accomodationContainer').hide()
                            break;
                    }


                    if (typeof raw.data !== 'undefined') {
                        dataSet = raw.data;
                    }

                    return dataSet;
                }
            },
        },
        pageSize: 10,
        serverPaging: true,
        serverFiltering: true,
        serverSorting: false,
    },
    layout: {
        scroll: false,
        footer: false,
    },
    sortable: true,
    pagination: true,
    columns: [{
        field: 'STUDENT_NAME',
        title: 'Name',
        type: 'text',
        width: 180,
        template: function (row) {
            return `<a class="font-weight-bolder" href="${BASE_URL + 'detail_student?id=' + row.ID}" target="_blank">${row.NAME}</a>`;
        }
    },
    {
        field: 'UNI_NAME',
        title: '<span id="colIden">University</span>',
        width: 180,
        template: function (row) {

            if (row.ACCOMODATION_NAME != null) {
                return `<span class="font-weight-bolder">${row.ACCOMODATION_NAME}</span>`;
            } else if (row.INSURANCE_TYPE != null) {
                return `<span class="font-weight-bolder">${row.INSURANCE_TYPE}</span>`;
            } else {
                return `<span class="font-weight-bolder">${row.UNI_NAME}</span>`;
            }

        }
    },
    {
        field: 'LOC_NAME',
        title: 'Branch',
        width: 100,
        template: function (row) {
            return `<span>${row.BRANCH == 'SUB' ? 'Sub Agent' : row.BRANCH}</span>`;
        }
    },
    {
        field: 'NAME',
        title: 'Counsellor',
        width: 100,
        template: function (row) {
            return `<span>${row.COUNSELLOR_NAME}</span>`;
        }
    },
    {
        field: 'INTAKE_MM',
        title: 'Intake',
        width: 130,
        template: function (row) {
            return `<span>${dateFormatter(row.INTAKE, 'MONTH_SHORT')}</span>`;
        }
    },
    {
        field: '',
        title: 'Action',
        width: 100,
        template: function (row) {
            return `<button class="btnDeleteSchool btn btn-sn btn-light-warning" data-rid="${row.ID}>Edit</button>`;
        }
    }
    ],
})

const invoiceSubtable = function subTableInit(e) {
    $('<div/>').attr('id', 'child_data_ajax_' + e.data.INVOICE_ID)
        .addClass('scroll scroll-pull')
        .appendTo(e.detailCell).KTDatatable({
            data: {
                type: 'remote',
                source: {
                    read: {
                        url: BASE_URL + 'C_Finance/getStudentCommissionDetails',
                        params: {
                            // custom query params
                            id: e.data.INVOICE_ID,
                            type: 'INVOICE_STUDENTS'
                        },
                        map: function (raw) {
                            const dataSet = raw.data;
                            return dataSet;
                        }
                    },
                },
                pageSize: 5,
                serverPaging: false,
                serverFiltering: false,
                serverSorting: false,
            },
            layout: {
                scroll: false,
                footer: false,
                spinner: {
                    type: 1,
                    theme: 'default',
                },
            },
            pagination: false,
            sortable: true,
            columns: [{
                field: 'STUDENT_NAME',
                title: 'Name',
                textAlign: 'center',
                template: function (row) {
                    return `<div class="text-primary font-weight-bolder">
                                <a href="${BASE_URL + 'detail_student?id=' + row.STUDENT_ID}">
                                    ${row.STUDENT_NAME}
                                </a>
                            </div>
                            <span class="text-muted">
                                ${row.BRANCH_NAME}    
                            </span>`
                },
            },
            {
                field: 'COMMISSION_STATUS',
                title: 'Status',
                textAlign: 'center',
                width: 70,
                template: function (row) {

                    const curObj = {
                        class: null,
                        text: null
                    }

                    switch (row.COMMISSION_STATUS) {
                        case 'PAID':
                            curObj.class = 'label-light-success'
                            curObj.text = 'Paid'
                            break;

                        case 'PARTIAL':
                            curObj.class = 'label-light-info'
                            curObj.text = 'Partial'
                            break;

                        case 'PENDING':
                            curObj.class = 'label-light-warning'
                            curObj.text = 'Pending'
                            break;

                        case 'UNPAID':
                            curObj.class = 'label-light-danger'
                            curObj.text = 'Unpaid'
                            break;
                    }

                    if (row.COMMISSION_STATUS == 'PAID') {
                        return `<a class="label font-weight-bold label-lg text-center ${curObj.class} label-inline" href="${row.FILE_LIST}" target="_blank">${curObj.text}</a>`;
                    } else {
                        return `<span class="label font-weight-bold label-lg text-center ${curObj.class} label-inline">${curObj.text}</span>`;
                    }

                },
            },
            {
                field: 'PROGRAM_NAME',
                title: 'Program',
                textAlign: 'center',
                width: 180,
                template: function (row) {

                    return `<div class="font-weight-bolder">${row.PROGRAM_NAME}</div>
                            <span class="text-muted font-weight-bold">${row.PROGRAM_LEVEL}</span>`
                },
            },
            {
                field: 'COMMISSION_FINAL_VALUE',
                title: 'Commission',
                textAlign: 'center',
                width: 150,
                template: function (row) {

                    let curString = `<span class="font-weight-bolder">${row.COMMISSION_CURRENCY}</span> <span>${formatNumber(row.COMMISSION_VALUE)}</span>`

                    if (row.INSTALLMENT_ID != null) {
                        curString += `<br/><span class="font-weight-bolder mt-3">Installment ${row.INSTALLMENT_PERIOD}</span>`
                    }

                    return curString
                },
            },
            {
                field: 'ACTUAL_PAYMENT_CURRENCY',
                title: 'Actual',
                textAlign: 'center',
                width: 100,
                template: function (row) {

                    if (row.ACTUAL_PAYMENT_VALUE == null || row.ACTUAL_PAYMENT_VALUE == undefined) {
                        return '-'
                    }

                    return `<span class="font-weight-bolder">${row.ACTUAL_PAYMENT_CURRENCY}</span> <span>${formatNumber(row.ACTUAL_PAYMENT_VALUE)}</span>`
                },
            },
            {
                field: 'BRANCH_PERCENTAGE',
                title: 'Deduction',
                textAlign: 'center',
                sortable: false,
                width: 360,
                template: function (row) {

                    let finalString = `<div class="d-flex justify-content-center">`

                    if (row.BRANCH_PERCENTAGE != null && row.BRANCH_PERCENTAGE != '') {
                        finalString += `<div class="d-flex flex-column mr-5">
                                            <span class="font-weight-bolder text-muted">Branch (${row.BRANCH_NAME})</span>
                                            <div class="d-flex flex-row justify-content-center">
                                                <span class="font-weight-bolder mr-2">${row.BRANCH_CURRENCY}</span> 
                                                <span>${formatNumber(row.BRANCH_PERCENTAGE)}</span>
                                            </div>
                                        </div>`
                    }

                    if (row.SUBAGENT_PERCENTAGE != null && row.SUBAGENT_PERCENTAGE != '') {
                        finalString += `<div class="d-flex flex-column mr-5">
                                            <span class="font-weight-bolder text-muted">Subagent (${row.SUBAGENT_NAME})</span>
                                            <div class="d-flex flex-row justify-content-center">
                                                <span class="font-weight-bolder mr-2">${row.SUBAGENT_CURRENCY}</span> 
                                                <span>${formatNumber(row.SUBAGENT_PERCENTAGE)}</span>
                                            </div>
                                        </div>`
                    }

                    if (row.SCHOLARSHIP_PERCENTAGE != null && row.SCHOLARSHIP_PERCENTAGE != '') {
                        finalString += `<div class="d-flex flex-column">
                                            <span class="font-weight-bolder text-muted">Scholarship</span>
                                            <div class="d-flex flex-row justify-content-center">
                                                <span class="font-weight-bolder mr-2">${row.COMMISSION_CURRENCY}</span> 
                                                <span>${formatNumber(row.SCHOLARSHIP_PERCENTAGE)}</span>
                                            </div>
                                        </div>`
                    }

                    if (row.OTHERS_DEDUCTION != null && row.OTHERS_DEDUCTION != '') {
                        const parseObj = JSON.parse(row.OTHERS_DEDUCTION)
                        let curAmount = 0

                        for (let i = 0; i < parseObj.length; i++) {
                            curAmount = curAmount + parseMysqlNumber(parseObj[i].value)
                        }

                        finalString += `<div class="d-flex flex-column">
                                            <span class="font-weight-bolder text-muted">Others Deduction</span>
                                            <div class="d-flex flex-row justify-content-center">
                                                <span class="font-weight-bolder mr-2">${row.COMMISSION_CURRENCY}</span> 
                                                <span>${formatNumber(curAmount)}</span>
                                            </div>
                                        </div>`
                    }

                    finalString += '</div>'

                    return finalString
                },
            },
            {
                field: '',
                title: 'Action',
                type: 'text',
                width: 180,
                textAlign: 'center',
                template: function (row) {
                    if (row.COMMISSION_STATUS != 'PAID') {
                        return `<button class="btn btn-light-warning btn-invoice-payment" data-type="${row.DATA_TYPE}" data-student-id="${row.STUDENT_ID}" data-invoice-id="${row.INVOICE_ID}">Payment</button>`
                    } else {
                        return ``
                    }
                }
            }
            ],
        });
}

const commissionTable = $('#commissionTable').KTDatatable({
    data: {
        type: 'remote',
        saveState: false,
        source: {
            read: {
                url: BASE_URL + 'C_Finance/getStudentCommissionDetails',
                params: {
                    type: 'STUDENT'
                },
                map: function (raw) {
                    let dataSet = raw;

                    $('#studentCounter').html(parseInt(raw.total).toLocaleString('id-ID'))

                    if (typeof raw.data !== 'undefined') {
                        dataSet = raw.data;
                    }

                    return dataSet;
                }
            },
        },
        pageSize: 10,
        serverPaging: false,
        serverFiltering: true,
        serverSorting: false,
    },
    layout: {
        scroll: false,
        footer: false,
    },
    sortable: false,
    pagination: true,
    columns: [{
        field: 'STUDENT_NAME',
        title: 'Student',
        type: 'text',
        width: 240,
        template: function (row) {

            const curStaging = generateStaging(row.STATUS);

            return `<div class="font-weight-bolder">
                        <a href="${BASE_URL + 'leads/detail?id=' + row.STUDENT_ID}" >${row.STUDENT_NAME} <span class="ml-3 label label-inline font-weight-bold label-lg ${curStaging.label} ">${curStaging.text}</span></a>
                    </div>
                    <span class="font-weight-bold text-muted">${row.COUNSELLOR_NAME} - ${row.BRANCH_LOCATION}</span>`
        }
    },
    {
        field: 'PROGRAM_NAME',
        title: 'Program',
        textAlign: 'center',
        width: 240,
        template: function (row) {

            return `<div class="font-weight-bolder">${row.PROGRAM_NAME}</div>
                    <span class="text-muted font-weight-bold">${row.PROGRAM_LEVEL}</span>`
        },
    },
    {
        field: 'UNIVERSITY_NAME',
        title: 'University',
        type: 'text',
        textAlign: 'center',
        width: 170,
        template: function (row) {
            return `<div class="font-weight-bolder">
                      ${row.UNIVERSITY_NAME}
                    </div>
                    <span class="font-weight-bold text-muted">Intake ${row.INTAKE_FORMATTED}</span>`
        }
    },
    {
        field: 'CALCULATION_METHOD',
        title: 'Type',
        width: 120,
        textAlign: 'center',
        template: function (row) {

            let curText = null
            let comValue = null

            switch (row.CALCULATION_METHOD) {
                case 'FLAT':
                    curText = 'Flat'
                    break;

                case 'TIERING':
                    curText = 'Tiering'
                    break;

                case 'PERCENTAGE':
                    curText = 'Percentage'
                    break;
            }

            if (row.COMMISSION_VALUE == null || row.COMMISSION_VALUE == '') {
                return `-`
            }

            /** Kalau tiering, liat dia ada persen atau engga */
            if (row.CALCULATION_METHOD == 'TIERING') {
                const perIndex = row.COMMISSION_VALUE.indexOf('%')

                if (perIndex === -1) {
                    comValue = parseInt(row.COMMISSION_VALUE).toLocaleString('id-ID') + ' ' + row.COMMISSION_CURRENCY_ISO
                } else {
                    comValue = row.COMMISSION_VALUE
                }
            } else {
                comValue = parseInt(row.COMMISSION_VALUE).toLocaleString('id-ID') + ' ' + row.COMMISSION_CURRENCY_ISO
            }

            return `<div class="font-weight-bolder">${curText}</div>
                    <div class="font-weight-bolder text-muted">${comValue}</div>`

        }
    },
    {
        field: 'COMMISSION_STATUS',
        title: 'Status',
        textAlign: 'center',
        width: 110,
        template: function (row) {

            const curObj = {
                class: null,
                text: null
            }

            if (row.INSTALLMENT_ID == null) {
                switch (row.COMMISSION_STATUS) {
                    case 'PAID':
                        curObj.class = 'label-light-success'
                        curObj.text = 'Paid'
                        break;

                    case 'PARTIAL':
                        curObj.class = 'label-light-info'
                        curObj.text = 'Partial'
                        break;

                    case 'PENDING':
                        curObj.class = 'label-light-danger'
                        curObj.text = 'Pending'
                        break;

                    case 'UNPAID':
                        curObj.class = 'label-light-warning'
                        curObj.text = 'Unpaid'
                        break;

                    default:
                        curObj.class = 'label-light-danger'
                        curObj.text = 'Unprocessed'
                        break;
                }
            } else if (row.INSTALLMENT_ID != null) {
                if (row.COMMISSION_STATUS == 'PARTIAL') {
                    curObj.class = ' label-light-info '
                    curObj.text = 'Partially Paid'
                } else if (row.COMMISSION_STATUS == 'PAID') {
                    curObj.class = ' label-light-success '
                    curObj.text = 'Fully Paid'
                } else {
                    curObj.class = ' label-light-info '
                    curObj.text = 'Installment'
                }
            }

            return `<span class="label font-weight-bold label-lg text-center ${curObj.class} label-inline">${curObj.text}</span>`;
        },
    }],
})

const accomodationTable = $('#accomodationTable').KTDatatable({
    data: {
        type: 'remote',
        saveState: false,
        source: {
            read: {
                url: BASE_URL + 'C_Finance/getStudentCommissionDetails',
                params: {
                    type: 'ACCOMODATION'
                },
                map: function (raw) {
                    let dataSet = raw;

                    $('#accomodationTrackerCounter').html(parseInt(raw.total).toLocaleString('id-ID'))

                    if (typeof raw.data !== 'undefined') {
                        dataSet = raw.data;
                    }

                    return dataSet;
                }
            },
        },
        pageSize: 10,
        serverPaging: false,
        serverFiltering: true,
        serverSorting: false,
    },
    layout: {
        scroll: false,
        footer: false,
    },
    sortable: false,
    pagination: true,
    columns: [{
        field: 'STUDENT_NAME',
        title: 'Student',
        type: 'text',
        width: 240,
        template: function (row) {

            const curStaging = generateStaging(row.STATUS);

            return `<div class="font-weight-bolder">
                        <a href="${BASE_URL + 'leads/detail?id=' + row.STUDENT_ID}" >${row.STUDENT_NAME} <span class="ml-3 label label-inline font-weight-bold label-lg ${curStaging.label} ">${curStaging.text}</span></a>
                    </div>
                    <span class="font-weight-bold text-muted">${row.COUNSELLOR_NAME} - ${row.BRANCH_LOCATION}</span>`
        }
    },
    {
        field: 'UNIVERSITY_NAME',
        title: 'University',
        textAlign: 'center',
        width: 240,
        template: function (row) {
            return `<div class="font-weight-bolder mt-3">${row.UNIVERSITY_NAME}</div>
                    <span class="font-weight-bold text-muted">Intake ${row.INTAKE}</span>`
        },
    },
    {
        field: 'CHECK_IN',
        title: 'Accomodation',
        textAlign: 'center',
        width: 240,
        template: function (row) {

            let curString = ''

            if (row.ACCOMODATION_NAME != null) {
                curString += `<div class="font-weight-bolder">${row.ACCOMODATION_NAME}</div>`
            }

            if (row.CITY != null && row.CITY != '') {
                curString += `<span class="text-muted font-weight-bold">${row.CITY}</span> <br/>`
            }

            if (row.CHECK_IN != null && row.CHECK_OUT != null) {
                curString += `<span class="font-weight-bold">${row.CHECK_IN} - ${row.CHECK_OUT}</span>`
            } else {
                curString += `<strong class="text-danger">Incomplete Data</strong>`
            }

            return curString
        },
    },
    {
        field: 'RENTAL_PAYMENT_TYPE',
        title: 'Rental Payment',
        width: 120,
        textAlign: 'center',
        template: function (row) {

            if (row.RENTAL_PAYMENT_TYPE == undefined || row.RENTAL_PAYMENT_TYPE == '' || row.RENTAL_PAYMENT_TYPE == null) {
                return `<strong class="text-danger">Incomplete Data</strong>`
            }

            let curText = null
            let comValue = null

            switch (row.RENTAL_PAYMENT_TYPE) {
                case 'WEEKLY':
                    curText = 'Weekly'
                    break;

                case 'MONTHLY':
                    curText = 'Monthly'
                    break;

                case 'YEARLY':
                    curText = 'Yearly'
                    break;
            }

            if (row.RENTAL_PRICE != null) {
                comValue = parseInt(row.RENTAL_PRICE).toLocaleString('id-ID') + ' ' + row.RENTAL_CURRENCY_DESC
            } else {
                comValue = '-'
            }

            return `<div class="font-weight-bolder">${curText}</div>
                    <div class="font-weight-bolder text-muted">${comValue}</div>`

        }
    },
    {
        field: 'COMMISSION_STATUS',
        title: 'Status',
        textAlign: 'center',
        width: 110,
        template: function (row) {

            const curObj = {
                class: null,
                text: null
            }

            if (row.INSTALLMENT_ID == null) {
                switch (row.COMMISSION_STATUS) {
                    case 'PAID':
                        curObj.class = 'label-light-success'
                        curObj.text = 'Paid'
                        break;

                    case 'PARTIAL':
                        curObj.class = 'label-light-info'
                        curObj.text = 'Partial'
                        break;

                    case 'PENDING':
                        curObj.class = 'label-light-danger'
                        curObj.text = 'Pending'
                        break;

                    case 'UNPAID':
                        curObj.class = 'label-light-warning'
                        curObj.text = 'Unpaid'
                        break;

                    default:
                        curObj.class = 'label-light-danger'
                        curObj.text = 'Unprocessed'
                        break;
                }
            } else if (row.INSTALLMENT_ID != null) {
                if (row.COMMISSION_STATUS == 'PARTIAL') {
                    curObj.class = ' label-light-info '
                    curObj.text = 'Partially Paid'
                } else if (row.COMMISSION_STATUS == 'PAID') {
                    curObj.class = ' label-light-success '
                    curObj.text = 'Fully Paid'
                } else {
                    curObj.class = ' label-light-info '
                    curObj.text = 'Installment'
                }
            }

            return `<span class="label font-weight-bold label-lg text-center ${curObj.class} label-inline">${curObj.text}</span>`;
        },
    }],
})

const invoiceTable = $('#invoiceTable').KTDatatable({
    data: {
        type: 'remote',
        saveState: false,
        source: {
            read: {
                url: BASE_URL + 'C_Finance/getStudentCommissionDetails',
                params: {
                    type: 'INVOICE_LIST'
                },
                map: function (raw) {
                    let dataSet = raw;

                    $('#invoiceCounter').html(parseInt(raw.total).toLocaleString('id-ID'))

                    if (typeof raw.data !== 'undefined') {
                        dataSet = raw.data;
                    }

                    return dataSet;
                }
            },
        },
        pageSize: 10,
        serverPaging: false,
        serverFiltering: true,
        serverSorting: false,
    },
    layout: {
        scroll: false,
        footer: false,
    },
    detail: {
        title: 'View indicator details',
        content: invoiceSubtable,
    },
    sortable: false,
    pagination: true,
    columns: [{
        field: 'INVOICE_ID',
        title: '',
        sortable: false,
        width: 10,
        textAlign: 'center',
    },
    {
        field: 'INVOICE_NUMBER',
        title: 'University',
        type: 'text',
        width: 240,
        template: function (row) {
            return `<span class="font-weight-bold text-muted"><em>${row.INVOICE_NUMBER}</em></span>
                    <div class="font-weight-bolder">
                        <span class="h5">${row.UNI_NAME}</span>
                    </div>
                    <small class="text-muted">Billed to </small> 
                    <span class="ml-1 text-dark font-weight-normal">${row.BILLING_TO}</span>`
        }
    },
    {
        field: 'TOTAL_STUDENT',
        title: 'Students',
        textAlign: 'center',
        width: 100,
        template: function (row) {
            return `<div class="font-weight-bolder">${parseInt(row.TOTAL_REGULAR_PAYMENT) + parseInt(row.TOTAL_INSTALLMENT_PAYMENT)} Student(s)</div>`
        },
    },
    {
        field: 'BILLING_DATE',
        title: 'Billing Date',
        type: 'text',
        textAlign: 'center',
        width: 120,
        template: function (row) {
            return `<div class="font-weight-bolder">
                      ${dateFormatter(row.BILLING_DATE)}
                    </div>`
        }
    },
    {
        field: 'TOTAL_AMOUNT',
        title: 'Amount',
        type: 'text',
        textAlign: 'center',
        width: 110,
        template: function (row) {
            return `<div class="font-weight-bolder">
                      ${row.TOTAL_CURRENCY_DESC + ' ' + formatNumber(row.TOTAL_AMOUNT)}
                    </div>`
        }
    },
    {
        field: 'BILLING_REMARKS',
        title: 'Remarks',
        type: 'text',
        textAlign: 'center',
        width: 125,
        template: function (row) {
            return row.BILLING_REMARKS
        }
    },
    {
        field: 'INVOICE_STATUS',
        title: 'Status',
        textAlign: 'center',
        width: 110,
        template: function (row) {

            const curObj = {
                class: null,
                text: null
            }

            switch (row.INVOICE_STATUS) {
                case 'PAID':
                    curObj.class = 'label-light-success'
                    curObj.text = 'Paid'
                    break;

                case 'PARTIAL':
                    curObj.class = 'label-light-info'
                    curObj.text = 'Partial'
                    break;

                case 'PENDING':
                    curObj.class = 'label-light-info'
                    curObj.text = 'Created'
                    break;

                case 'UNPAID':
                    curObj.class = 'label-light-danger'
                    curObj.text = 'Unpaid'
                    break;

                case 'ON_PROCESS':
                    curObj.class = 'label-light-primary'
                    curObj.text = 'On Process'
                    break;

                default:
                    curObj.class = 'label-light-danger'
                    curObj.text = 'Unprocessed'
                    break;
            }

            return `<span class="label font-weight-bold label-lg text-center ${curObj.class} label-inline">${curObj.text}</span>`;
        },
    },
    {
        field: '',
        title: 'Action',
        type: 'text',
        textAlign: 'center',
        width: 285,
        template: function (row) {
            if (['UNPAID', 'ON_PROCESS'].includes(row.INVOICE_STATUS)) {
                return `<a href="${encodeURI(BASE_URL + 'finance/edit-invoice?id=' + row.INVOICE_ID)}" class="btn btn-light-warning btn-general-invoice ml-2">Edit</button>
                        <a href="${encodeURI(BASE_URL + 'finance/generate-invoice?id=' + row.INVOICE_ID)}" target="_blank" class="btn btn-light-info btn-general-invoice ml-2">View</button>`
            } else {
                return `<a href="${encodeURI(BASE_URL + 'finance/generate-invoice?id=' + row.INVOICE_ID)}" class="btn btn-light-info btn-general-invoice ml-3">View</button>`
            }
        }
    }],
})

// const commissionTable = $('#commissionTable').KTDatatable({
//     data: {
//         type: 'remote',
//         saveState: false,
//         source: {
//             read: {
//                 url: BASE_URL + 'C_Finance/getStudentCommissionDetails',
//                 params: {
//                     type: 'STUDENT'
//                 },
//                 map: function (raw) {
//                     let dataSet = raw;

//                     $('#studentCounter').html(parseInt(raw.total).toLocaleString('id-ID'))

//                     if (typeof raw.data !== 'undefined') {
//                         dataSet = raw.data;
//                     }

//                     return dataSet;
//                 }
//             },
//         },
//         pageSize: 10,
//         serverPaging: false,
//         serverFiltering: true,
//         serverSorting: false,
//     },
//     layout: {
//         scroll: false,
//         footer: false,
//     },
//     sortable: false,
//     pagination: true,
//     columns: [{
//         field: 'STUDENT_NAME',
//         title: 'Student',
//         type: 'text',
//         width: 180,
//         template: function (row) {
//             return `< div class="font-weight-bolder" >
//                         <a href="${BASE_URL + 'leads/detail?id=' + row.STUDENT_ID}" >${row.STUDENT_NAME}</a>
//                     </>
//                     <span class="font-weight-bold text-muted">${row.COUNSELLOR_NAME} - ${row.BRANCH_LOCATION}</span>`
//         }
//     },
//     {
//         field: 'INTAKE',
//         title: 'Intake',
//         textAlign: 'center',
//         width: 125,
//         template: function (row) {

//             if (row.INSTALLMENT_STATUS) {
//                 return `<span class="font-weight-bolder">${row.INTAKE_FORMATTED}</span><br/>
//                         <span class="text-muted">Installment ${row.INSTALLMENT_PERIOD}</span>`
//             } else {
//                 return `<span class="font-weight-bolder">${row.INTAKE_FORMATTED}</span>`
//             }

//         }
//     },
//     {
//         field: 'TOTAL_STUDENT',
//         title: 'Student(s)',
//         width: 90,
//         template: function (row) {
//             return `<span class="font-weight-bolder text-success">${row.NUMBER_STUDENTS}</span>`
//         }
//     },
//     {
//         field: 'CALCULATION_METHOD',
//         title: 'Type',
//         width: 120,
//         template: function (row) {

//             let curText = null

//             switch (row.CALCULATION_METHOD) {
//                 case 'FLAT':
//                     curText = 'Flat'
//                     break;

//                 case 'TIERING':
//                     curText = 'Tiering'
//                     break;

//                 case 'PERCENTAGE':
//                     curText = 'Percentage'
//                     break;
//             }

//             return `<span class="font-weight-bolder">${curText}</span>`
//         }
//     },
//     {
//         field: 'COMMISSION_VALUE',
//         title: 'Commission Value',
//         width: 120,
//         sortable: false,
//         template: function (row) {

//             if (row.CALCULATION_METHOD === 'PERCENTAGE') {
//                 return `<span class="font-weight-bolder text-success">${parseInt(row.COMMISSION_VALUE).toLocaleString('id-ID')}%</span>`
//             } else {
//                 return `<span class="font-weight-bolder text-success">${parseInt(row.COMMISSION_VALUE).toLocaleString('id-ID')} ${row.COMMISSION_CURRENCY}</span>`
//             }

//         }
//     },
//     {
//         field: 'COMMISSION_FINAL_VALUE',
//         title: 'Actual Value <i class="fa fas fa-info-circle icon-sm text-muted" style="margin-left: -11px;margin-top: -8px;" data-toggle="popover" data-trigger="hover" data-content="Final commission value after deduction"></i>',
//         width: 120,
//         sortable: false,
//         template: function (row) {
//             return `<span class="font-weight-bolder text-success">${parseInt(row.COMMISSION_FINAL_VALUE).toLocaleString('id-ID')} ${row.COMMISSION_FINAL_CURRENCY}</span>`
//         }
//     },
//     {
//         field: 'STATUS',
//         title: 'Status',
//         width: 80,
//         template: function (row) {

//             const curObj = {
//                 class: null,
//                 text: null
//             }

//             switch (getTransStatus(row.COMMISSION_STATUS)) {
//                 case 'PAID':
//                     curObj.class = 'label-light-success'
//                     curObj.text = 'Paid'
//                     break;

//                 case 'PARTIAL':
//                     curObj.class = 'label-light-info'
//                     curObj.text = 'Partial'
//                     break;

//                 case 'PENDING':
//                     curObj.class = 'label-light-warning'
//                     curObj.text = 'Pending'
//                     break;

//                 case 'UNPAID':
//                     curObj.class = 'label-light-danger'
//                     curObj.text = 'Unpaid'
//                     break;
//             }

//             return `<span class="label font-weight-bold label-lg text-center ${curObj.class} label-inline">${curObj.text}</span>`;
//         }
//     },

//     }],
// })

export {
    studentTable,
    commissionTable,
    invoiceTable,
    parseNumber,
    formatNumber,
    accomodationTable
}